import { UserService } from 'src/app/services/user.service';
import { Component, Input, SimpleChanges, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core'
import { DocumentoService } from '../../services/documento.service';
import { WizardComponent } from 'angular-archwizard';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { crearBorradorComponent } from '../borradores/crearBorrador/crearBorrador.component';
import { NgxSpinnerService } from 'ngx-spinner';

//Prueba NGRX STORE
import { Store } from '@ngrx/store';
import { Form } from 'src/app/models/form.model';
import { FilemakerService } from 'src/app/services/filemaker.service';
import { Router } from '@angular/router';
import * as FormActions from '../../reducers/actions/forms.actions';
import { PropietarioComponent } from '../formulario/propietario/propietario.component';
import { Tipo_propiedadComponent } from '../formulario/tipo_propiedad/tipo_propiedad.component';
import { Tipo_solicitudComponent } from '../formulario/tipo_solicitud/tipo_solicitud.component';
import { CipComponent } from '../formulario/cip/cip.component';
import { Registro_bienesComponent } from '../formulario/registro_bienes/registro_bienes.component';
import { DeclaracionComponent } from '../formulario/declaracion/declaracion.component';
import { PropiedadComponent } from '../formulario/propiedad/propiedad.component';
import { RepresentanteComponent } from '../formulario/representante/representante.component';
import { Permiso_notariadoComponent } from '../formulario/permiso_notariado/permiso_notariado.component';
import { EmpresaComponent } from '../formulario/empresa/empresa.component';
import { ArquitectoComponent } from '../formulario/arquitecto/arquitecto.component';
import { ConstructoraComponent } from '../formulario/constructora/constructora.component';
import { ConstructoresComponent } from '../formulario/constructores/constructores.component';
import { InformeComponent } from '../formulario/informe/informe.component';
import { IndependienteComponent } from '../formulario/independiente/independiente.component';
import { AntecedentesComponent } from '../formulario/antecedentes/antecedentes.component';
import { PlazoComponent } from '../formulario/plazo/plazo.component';
import { ProyectoComponent } from '../formulario/proyecto/proyecto.component';
import { Formulario11Component } from '../formulario/formulario11/formulario11.component';
import { ArchivosComponent } from '../formulario/archivos/archivos.component';
import { ResumenComponent } from '../formulario/resumen/resumen.component';
import { Tipo_recepcionComponent } from '../formulario/tipo_recepcion/tipo_recepcion.component';
import { PermisosComponent } from '../formulario/permisos/permisos.component';
import { Datos_proyectoComponent } from '../formulario/datos_proyecto/datos_proyecto.component';
import { Caracteristica_proyectoComponent } from '../formulario/caracteristica_proyecto/caracteristica_proyecto.component';
import { RecepcionComponent } from '../formulario/recepcion/recepcion.component';
import { Formulario13Component } from '../formulario/formulario13/formulario13.component';
import { AmpliacionComponent } from '../formulario/ampliacion/ampliacion.component';
import { Formulario15Component } from '../formulario/formulario15/formulario15.component';
import { Recepcion_parcialComponent } from '../formulario/recepcion_parcial/recepcion_parcial.component';
import { Formulario17Component } from '../formulario/formulario17/formulario17.component';
import { Antecedentes_edifComponent } from '../formulario/antecedentes_edif/antecedentes_edif.component';
import { superficieComponent } from '../formulario/superficie/superficie.component';
import { UnidadesComponent } from '../formulario/unidades/unidades.component';
import { DisposicionComponent } from '../formulario/disposicion/disposicion.component';
import { Permisos_recepComponent } from '../formulario/permisos_recep/permisos_recep.component';
import { clasificacionComponent } from '../formulario/clasificacion/clasificacion.component';
import { Formulario19Component } from '../formulario/formulario19/formulario19.component';
import { tipo_aprobacionComponent } from '../formulario/tipo_aprobacion/tipo_aprobacion.component';
import { DestinoComponent } from '../formulario/destino/destino.component';
import { Superficie_anteproyectoComponent } from '../formulario/superficie_anteproyecto/superficie_anteproyecto.component';
import { Normas_urbanisticasComponent } from '../formulario/normas_urbanisticas/normas_urbanisticas.component';
import { Disposiciones_espComponent } from '../formulario/disposiciones_especiales/disposiciones_especiales.component';
import { AutorizacionesComponent } from '../formulario/autorizaciones/autorizaciones.component';
import { Uso_publicoComponent } from '../formulario/uso_publico/uso_publico.component';
import { Anteproy_condominioComponent } from '../formulario/anteproy_condominio/anteproy_condominio.component';
import { CondicionesComponent } from '../formulario/condiciones/condiciones.component';
import { Permisos_recepcionesComponent } from '../formulario/permisos_recepciones/permisos_recepciones.component';
import { Formulario21Component } from '../formulario/formulario21/formulario21.component';
import { Tipo_permisoComponent } from '../formulario/tipo_permiso/tipo_permiso.component';
import { CalculistaComponent } from '../formulario/calculista/calculista.component';
import { Informe_revisorComponent } from '../formulario/informe_revisor/informe_revisor.component';
import { RevisorComponent } from '../formulario/revisor/revisor.component';
import { Caract_anteproyectoComponent } from '../formulario/caract_anteproyecto/caract_anteproyecto.component';
import { Otras_solicitudesComponent } from '../formulario/otras_solicitudes/otras_solicitudes.component';
import { Formulario23Component } from '../formulario/formulario23/formulario23.component';
import { S_permiso_primitivoComponent } from '../formulario/s_permiso_primitivo/s_permiso_primitivo.component';
import { Cambio_profesionalComponent } from '../formulario/cambio_profesional/cambio_profesional.component';
import { Cambio_destinoComponent } from '../formulario/cambio_destino/cambio_destino.component';
import { Superficie_proyecto_modificadoComponent } from '../formulario/superficie_proyecto_modificado/superficie_proyecto_modificado.component';
import { Nuevas_normasComponent } from '../formulario/nuevas_normas/nuevas_normas.component';
import { Formulario25Component } from '../formulario/formulario25/formulario25.component';
import { Profesional_compComponent } from '../formulario/profesional_comp/profesional_comp.component';
import { InspectorObraComponent } from '../formulario/inspector_obra/inspector_obra.component';
import { Tipo_proyectoComponent } from '../formulario/tipo_proyecto/tipo_proyecto.component';
import { Perm_recep_antComponent } from '../formulario/perm_recep_ant/perm_recep_ant.component';
import { Formulario27Component } from '../formulario/formulario27/formulario27.component';
import { Tipo_loteoComponent } from '../formulario/tipo_loteo/tipo_loteo.component';
import { Caract_anteproy_loteoComponent } from '../formulario/caract_anteproy_loteo/caract_anteproy_loteo.component';
import { Porcentajes_anteproyComponent } from '../formulario/porcentajes_anteproy/porcentajes_anteproy.component';
import { Cond_anteproyComponent } from '../formulario/cond_anteproy/cond_anteproy.component';
import { Formulario310Component } from '../formulario/formulario310/formulario310.component';
import { Tipo_divisionComponent } from '../formulario/tipo_division/tipo_division.component';
import { Caract_divisionComponent } from '../formulario/caract_division/caract_division.component';
import { Caract_fusionComponent } from '../formulario/caract_fusion/caract_fusion.component';
import { Loteo_constComponent } from '../formulario/loteo_const/loteo_const.component';
import { Permiso_urbComponent } from '../formulario/permiso_urb/permiso_urb.component';
import { Formulario33Component } from '../formulario/formulario33/formulario33.component';
import { Formulario31Component } from '../formulario/formulario31/formulario31.component';
import { Tipo_modComponent } from '../formulario/tipo_mod/tipo_mod.component';
import { Reso_modComponent } from '../formulario/reso_mod/reso_mod.component';
import { Mod_parcialComponent } from '../formulario/mod_parcial/mod_parcial.component';
import { Caract_proy_modComponent } from '../formulario/caract_proy_mod/caract_proy_mod.component';
import { Planos_modComponent } from '../formulario/planos_mod/planos_mod.component';
import { Formulario36Component } from '../formulario/formulario36/formulario36.component';
import { Caract_solicitudComponent } from '../formulario/caract_solicitud/caract_solicitud.component';
import { Caract_proy_garantiaComponent } from '../formulario/caract_proy_garantia/caract_proy_garantia.component';
import { Lotes_enajenarComponent } from '../formulario/lotes_enajenar/lotes_enajenar.component';
import { Formulario38Component } from '../formulario/formulario38/formulario38.component';
import { Formulario41Component } from '../formulario/formulario41/formulario41.component';
import { Tipo_garantiaComponent } from '../formulario/tipo_garantia/tipo_garantia.component';
import { Caract_solComponent } from '../formulario/caract_sol/caract_sol.component';
import { Cuenta_con_modComponent } from '../formulario/cuenta_con_mod/cuenta_con_mod.component';
import { Formulario43Component } from '../formulario/formulario43/formulario43.component';
import { Tipo_solicitud_def_urbComponent } from '../formulario/tipo_solicitud_def_urb/tipo_solicitud_def_urb.component';
import { Formulario45Component } from '../formulario/formulario45/formulario45.component';
import { Tipo_condominioComponent } from '../formulario/tipo_condominio/tipo_condominio.component';
import { Reglamento_copropiedadComponent } from '../formulario/reglamento_copropiedad/reglamento_copropiedadcomponent';
import { Formulario56Component } from '../formulario/formulario56/formulario56.component';
import { Tipo_autorizacionComponent } from '../formulario/tipo_autorizacion/tipo_autorizacion.component';
import { Permiso_demolicionComponent } from '../formulario/permiso_demolicion/permiso_demolicion.component';
import { Formulario58Component } from '../formulario/formulario58/formulario58.component';
import { iif } from 'rxjs';
import { EmpresaConstructoraComponent } from '../formulario/empresa_constructora/empresa_constructora.component';
import { EmpresaProfesionalComponent } from '../formulario/empresa_profesional/empresa_profesional.component';
import { Formulario01Component } from '../formulario/formulario01/formulario01.component';
import { GLOBAL } from 'src/app/services/global';
import { BorradorStorageService } from '../../services/borrador-storage.service';
declare const swal: any;

interface AppState {
    form: Form;
}

@Component({
    selector: "msw-navbar",
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.css"],
    providers: [DocumentoService, UserService, FilemakerService]
})

export class NavbarComponent implements OnInit {

    @Input() form: Form;
    @Input() title: Form;
    tabs = [];
    actualForm = [];
    tempForm;
    @ViewChild('wizard') wizard: WizardComponent;
    wizardSteps: Array<Object>;
    tempWizard = [];
    start = 0;
    end = 0;
    limit = 4;
    actual = 0;
    avance: boolean = false;
    data = [];
    borradorId;
    infoBorrador;
    formulariofinal;
    resumen

    generico = GLOBAL.generico;
    //currentStep = 0;
    forms = [
        {
            "name": "0.1",
            "tabs": [{
                "header": 1,
                "title": "Propiedades y Propietario",
                "content": [Tipo_solicitudComponent, PropiedadComponent, PropietarioComponent],
                "valid": ["propiedad", "propietarios"]
            },
            {
                "header": 2,
                "title": "Representante",
                "content": [RepresentanteComponent],
            },
            {
                "header": 3,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 4,
                "title": "Documentos",
                "content": [ArchivosComponent],
                "valid": ["archivos_marcados"]
            },
            {
                "header": 5,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "1.1",
            "tabs": [{
                "header": 1,
                "title": "Propiedades",
                "content": [Tipo_solicitudComponent, CipComponent, Registro_bienesComponent, DeclaracionComponent, PropiedadComponent],
                "valid": ["cip", "propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Representante",
                "content": [RepresentanteComponent, Permiso_notariadoComponent]
            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 5,
                "title": "Constructora",
                "content": [ConstructoraComponent, ConstructoresComponent],
            },
            {
                "header": 6,
                "title": "Independiente",
                "content": [InformeComponent, IndependienteComponent],
            },
            {
                "header": 7,
                "title": "Antecedentes",
                "content": [AntecedentesComponent],
            },
            {
                "header": 8,
                "title": "Proyecto",
                "content": [ProyectoComponent, PlazoComponent],
            },
            {
                "header": 9,
                "title": "Formulario 1.1 (PDF)",
                "content": [Formulario11Component],
            },
            {
                "header": 10,
                "title": "Documentos",
                "content": [ArchivosComponent],
                "valid": ["archivos_marcados"]
            },
            {
                "header": 11,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "1.3",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_solicitudComponent, Tipo_recepcionComponent, PropiedadComponent],
                "valid": ["propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Representante",
                "content": [RepresentanteComponent, Permiso_notariadoComponent],
            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 5,
                "title": "Independiente",
                "content": [InformeComponent, IndependienteComponent],
            },
            {
                "header": 6,
                "title": "Permisos",
                "content": [Datos_proyectoComponent, PermisosComponent],
                "valid": ["Permisos"]
            },
            {
                "header": 7,
                "title": "Proyecto",
                "content": [Caracteristica_proyectoComponent, RecepcionComponent],
            },
            {
                "header": 8,
                "title": "Formulario 1.3",
                "content": [Formulario13Component],
            },
            {
                "header": 9,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 10,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "1.5",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [CipComponent, PropiedadComponent, Registro_bienesComponent, DeclaracionComponent],
                "valid": ["cip", "propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Representante",
                "content": [RepresentanteComponent, Permiso_notariadoComponent],
            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 5,
                "title": "Constructora",
                "content": [ConstructoraComponent, ConstructoresComponent],
            },
            {
                "header": 6,
                "title": "Antecedentes",
                "content": [AntecedentesComponent],
            },
            {
                "header": 7,
                "title": "Ampliación",
                "content": [AmpliacionComponent],
            },
            {
                "header": 8,
                "title": "Formulario 1.5",
                "content": [Formulario15Component],
            },
            {
                "header": 9,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 10,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "1.7",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_recepcionComponent, PropiedadComponent],
                "valid": ["propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Representante",
                "content": [RepresentanteComponent, Permiso_notariadoComponent],
            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 5,
                "title": "Permisos",
                "content": [PermisosComponent, Recepcion_parcialComponent],
                "valid": ["Permisos"]
            },
            {
                "header": 6,
                "title": "Formulario 1.7",
                "content": [Formulario17Component],
            },
            {
                "header": 7,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 8,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "1.9",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [CipComponent, Registro_bienesComponent, PropiedadComponent],
                "valid": ["cip", "propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Representante",
                "content": [RepresentanteComponent, Permiso_notariadoComponent],
            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 5,
                "title": "Profesional",
                "content": [EmpresaConstructoraComponent, EmpresaProfesionalComponent],
            },
            {
                "header": 6,
                "title": "Antecedentes",
                "content": [Antecedentes_edifComponent],
                "valid": ["antecedentes_edif"]
            },
            {
                "header": 7,
                "title": "Superficie",
                "content": [superficieComponent, DisposicionComponent],
            },
            {
                "header": 8,
                "title": "Edificación",
                "content": [UnidadesComponent],
            },
            {
                "header": 9,
                "title": "Permisos",
                "content": [Permisos_recepComponent],
            },
            {
                "header": 10,
                "title": "Clasificacion",
                "content": [clasificacionComponent],
            },
            {
                "header": 11,
                "title": "Formulario 1.9",
                "content": [Formulario19Component],
            },
            {
                "header": 12,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 13,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "2.1",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [tipo_aprobacionComponent, CipComponent, Registro_bienesComponent, DeclaracionComponent, PropiedadComponent],
                "valid": ["cip", "propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Representante",
                "content": [RepresentanteComponent, Permiso_notariadoComponent],
            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 5,
                "title": "Anteproyecto",
                "content": [DestinoComponent, Superficie_anteproyectoComponent],
            },
            {
                "header": 6,
                "title": "Normas",
                "content": [Normas_urbanisticasComponent, clasificacionComponent],
            },
            {
                "header": 7,
                "title": "Disposiciones",
                "content": [Disposiciones_espComponent, AutorizacionesComponent, Uso_publicoComponent],
            },
            {
                "header": 8,
                "title": "Unidades",
                "content": [UnidadesComponent, Anteproy_condominioComponent],
            },
            {
                "header": 9,
                "title": "Condiciones",
                "content": [CondicionesComponent],
            },
            {
                "header": 10,
                "title": "Permisos",
                "content": [Permisos_recepcionesComponent],
            },
            {
                "header": 11,
                "title": "Formulario 2.1",
                "content": [Formulario21Component],
            },
            {
                "header": 12,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 13,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "2.3",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_permisoComponent, CipComponent, Registro_bienesComponent, DeclaracionComponent, PropiedadComponent],
                "valid": ["cip", "propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Representante",
                "content": [RepresentanteComponent, Permiso_notariadoComponent],
            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent, CalculistaComponent, ConstructoresComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 5,
                "title": "Revisores",
                "content": [InformeComponent, IndependienteComponent, Informe_revisorComponent, RevisorComponent],
            },
            {
                "header": 6,
                "title": "Anteproyecto",
                "content": [Caract_anteproyectoComponent, DestinoComponent, Superficie_anteproyectoComponent],
            },
            {
                "header": 7,
                "title": "Normas",
                "content": [Normas_urbanisticasComponent, clasificacionComponent],
            },
            {
                "header": 8,
                "title": "Disposiciones",
                "content": [Disposiciones_espComponent, AutorizacionesComponent],
            },
            {
                "header": 9,
                "title": "Unidades",
                "content": [UnidadesComponent, Otras_solicitudesComponent],
            },
            {
                "header": 10,
                "title": "Permisos",
                "content": [Permisos_recepComponent],
            },
            {
                "header": 11,
                "title": "Formulario 2.3",
                "content": [Formulario23Component],
            },
            {
                "header": 12,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 13,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "2.5",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_permisoComponent, S_permiso_primitivoComponent, CipComponent, Registro_bienesComponent, DeclaracionComponent, PropiedadComponent],
                "valid": ["cip", "propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Representante",
                "content": [RepresentanteComponent, Permiso_notariadoComponent],
            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent, CalculistaComponent, ConstructoresComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 5,
                "title": "Revisores",
                "content": [InformeComponent, IndependienteComponent, Informe_revisorComponent, RevisorComponent, Cambio_profesionalComponent],
            },
            {
                "header": 6,
                "title": "Anteproyecto",
                "content": [Uso_publicoComponent, Cambio_destinoComponent, DestinoComponent, Superficie_proyecto_modificadoComponent],
            },
            {
                "header": 7,
                "title": "Normas",
                "content": [Nuevas_normasComponent, Normas_urbanisticasComponent, clasificacionComponent],
            },
            {
                "header": 8,
                "title": "Disposiciones",
                "content": [Disposiciones_espComponent, AutorizacionesComponent],
            },
            {
                "header": 9,
                "title": "Unidades",
                "content": [UnidadesComponent],
            },
            {
                "header": 10,
                "title": "Formulario 2.5",
                "content": [Formulario25Component],
            },
            {
                "header": 11,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 12,
                "title": "Resumen",
                "content": [ResumenComponent],
            }
            ]
        },
        {
            "name": "2.7",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_permisoComponent, Tipo_recepcionComponent, PropiedadComponent],
                "valid": ["propiedad"]
            },
            {
                "header": 2,
                "title": "Solicitantes",
                "content": [PropietarioComponent, Permiso_notariadoComponent, ArquitectoComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Revisor",
                "content": [InformeComponent, IndependienteComponent],
            },
            {
                "header": 4,
                "title": "Profesionales",
                "content": [ConstructoresComponent, Profesional_compComponent, InspectorObraComponent],
            },
            {
                "header": 5,
                "title": "Proyecto",
                "content": [Tipo_proyectoComponent],
            },
            {
                "header": 6,
                "title": "Permisos y Recepciones",
                "content": [Perm_recep_antComponent],
            },
            {
                "header": 7,
                "title": "Formulario 2.7",
                "content": [Formulario27Component],
            },
            {
                "header": 8,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 9,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "3.1",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_loteoComponent, Tipo_recepcionComponent, CipComponent, PropiedadComponent, DeclaracionComponent, Registro_bienesComponent],

            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent, Permiso_notariadoComponent],

            },
            {
                "header": 3,
                "title": "Arquitecto",
                "content": [ArquitectoComponent],
            },
            {
                "header": 4,
                "title": "Caracteristicas del anteproyecto de loteo",
                "content": [Caract_anteproy_loteoComponent, Porcentajes_anteproyComponent],
            },
            {
                "header": 5,
                "title": "Condicionantes del anteproyecto",
                "content": [Cond_anteproyComponent],
            },
            {
                "header": 6,
                "title": "Formulario 3.1",
                "content": [Formulario31Component],
            },
            {
                "header": 7,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 8,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "3.3",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_divisionComponent, Tipo_loteoComponent, CipComponent, PropiedadComponent, DeclaracionComponent, Registro_bienesComponent],

            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent, Permiso_notariadoComponent],

            },
            {
                "header": 3,
                "title": "Arquitecto",
                "content": [ArquitectoComponent],
            },
            {
                "header": 4,
                "title": "Caracteristicas del Proyecto",
                "content": [Caract_anteproyectoComponent, Caract_divisionComponent, Caract_fusionComponent, Caract_anteproy_loteoComponent],
            },
            {
                "header": 5,
                "title": "Caracteristicas del Proyecto",
                "content": [Porcentajes_anteproyComponent, Loteo_constComponent, Permiso_urbComponent],
            },
            {
                "header": 6,
                "title": "Formulario 3.3",
                "content": [Formulario33Component],
            },
            {
                "header": 7,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 8,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "3.6",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_modComponent, CipComponent, PropiedadComponent, DeclaracionComponent, Registro_bienesComponent],

            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent, Permiso_notariadoComponent],

            },
            {
                "header": 3,
                "title": "Arquitecto",
                "content": [ArquitectoComponent],
            },
            {
                "header": 4,
                "title": "Modificaciones",
                "content": [Reso_modComponent, Mod_parcialComponent, Caract_proy_modComponent],
            },
            {
                "header": 5,
                "title": "Caracteristicas del Proyecto",
                "content": [Porcentajes_anteproyComponent, Planos_modComponent],
            },
            {
                "header": 6,
                "title": "Formulario 3.6",
                "content": [Formulario36Component],
            },
            {
                "header": 7,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 8,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "3.8",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [PropiedadComponent, Caract_solicitudComponent],

            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent, Permiso_notariadoComponent],

            },
            {
                "header": 3,
                "title": "Arquitecto",
                "content": [ArquitectoComponent],
            },
            {
                "header": 4,
                "title": "Proyecto",
                "content": [Tipo_modComponent, Caract_proy_garantiaComponent],
            },
            {
                "header": 5,
                "title": "Lotes a enajenar",
                "content": [Lotes_enajenarComponent],
            },
            {
                "header": 6,
                "title": "Formulario 3.8",
                "content": [Formulario38Component],
            },
            {
                "header": 7,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 8,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "3.10",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [PropiedadComponent, Caract_solicitudComponent],

            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent, Permiso_notariadoComponent],

            },
            {
                "header": 3,
                "title": "Arquitecto",
                "content": [ArquitectoComponent],
            },
            {
                "header": 4,
                "title": "Proyecto",
                "content": [Tipo_modComponent, Caract_proy_garantiaComponent],
            },
            {
                "header": 5,
                "title": "Lotes a enajenar",
                "content": [Lotes_enajenarComponent],
            },
            {
                "header": 6,
                "title": "Formulario 3.10",
                "content": [Formulario310Component],
            },
            {
                "header": 7,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 8,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "4.1",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [CipComponent, PropiedadComponent, DeclaracionComponent, Registro_bienesComponent],

            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent, Permiso_notariadoComponent],

            },
            {
                "header": 3,
                "title": "Arquitecto",
                "content": [ArquitectoComponent],
            },
            {
                "header": 4,
                "title": "Caracteristicas del Proyecto",
                "content": [Caract_anteproy_loteoComponent, Porcentajes_anteproyComponent],
            },
            {
                "header": 5,
                "title": "Formulario 4.1",
                "content": [Formulario41Component],
            },
            {
                "header": 6,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 7,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "4.3",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_garantiaComponent, PropiedadComponent],

            },
            {
                "header": 2,
                "title": "Características de la solicitud",
                "content": [Caract_solComponent],

            },
            {
                "header": 3,
                "title": "Propietario",
                "content": [PropietarioComponent],

            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [ArquitectoComponent],
            },
            {
                "header": 5,
                "title": "Caracteristicas del Proyecto",
                "content": [Cuenta_con_modComponent, Lotes_enajenarComponent],
            },
            {
                "header": 6,
                "title": "Formulario 4.3",
                "content": [Formulario43Component],
            },
            {
                "header": 6,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 7,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "4.5",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_solicitud_def_urbComponent, PropiedadComponent],

            },
            {
                "header": 2,
                "title": "Características de la solicituda",
                "content": [Caract_solComponent],

            },
            {
                "header": 3,
                "title": "Propietario",
                "content": [PropietarioComponent, Permiso_notariadoComponent],

            },
            {
                "header": 4,
                "title": "Arquitecto",
                "content": [ArquitectoComponent],
            },
            {
                "header": 5,
                "title": "Caracteristicas del Proyecto",
                "content": [Caract_proy_garantiaComponent, Lotes_enajenarComponent],
            },
            {
                "header": 6,
                "title": "Formulario 4.5",
                "content": [Formulario45Component],
            },
            {
                "header": 6,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 7,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "5.6",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_condominioComponent, PropiedadComponent, Registro_bienesComponent],
                "valid": ["propiedad"]
            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent, RepresentanteComponent, Permiso_notariadoComponent],
                "valid": ["propietarios"]

            },
            {
                "header": 3,
                "title": "Arquitecto",
                "content": [EmpresaComponent, ArquitectoComponent],
                "valid": ["arquitectos"]
            },
            {
                "header": 4,
                "title": "Caracteristicas del Proyecto",
                "content": [Reglamento_copropiedadComponent],
            },
            {
                "header": 5,
                "title": "Formulario 5.6",
                "content": [Formulario56Component],
            },
            {
                "header": 6,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 7,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        },
        {
            "name": "5.8",
            "tabs": [{
                "header": 1,
                "title": "Propiedad",
                "content": [Tipo_autorizacionComponent, CipComponent, PropiedadComponent, Registro_bienesComponent],
                "valid": ["cip", "propiedad"]


            },
            {
                "header": 2,
                "title": "Propietario",
                "content": [PropietarioComponent, RepresentanteComponent, Permiso_notariadoComponent],
                "valid": ["propietarios"]
            },
            {
                "header": 3,
                "title": "Profesional Competente",
                "content": [Profesional_compComponent, EmpresaComponent],
            },
            {
                "header": 4,
                "title": "Permiso",
                "content": [Permiso_demolicionComponent],
            },
            {
                "header": 5,
                "title": "Formulario 5.8",
                "content": [Formulario58Component],
            },
            {
                "header": 6,
                "title": "Documentos adjuntos",
                "content": [ArchivosComponent],
                "valid": ["archivos"]
            },
            {
                "header": 7,
                "title": "Resumen",
                "content": [ResumenComponent],
            }

            ]
        }

    ]
    constructor(private _documentoService: DocumentoService,
        private _changeDetectionRef: ChangeDetectorRef,
        private dialog: MatDialog, private store: Store<AppState>,
        private spinner: NgxSpinnerService, private _userService: UserService,
        private snackBar: MatSnackBar, private filemaker: FilemakerService,
        private _router: Router,
        private borradorStorageService: BorradorStorageService
    ) {

        this.wizardSteps = [];


    }


    ngOnInit() {
        if (this.generico == true) {
            this.getDocumentos(localStorage.getItem("form"));
            console.log('Formulario generico', localStorage.getItem("form"))
        } else {

            this.getDocumentos(this.form);
            console.log('Formulario seleccionado', this.form)
        }
        /*    this.getDocumentos(this.form); */

        this.borradorStorageService.change.subscribe(changed => {


            this.borradorId = sessionStorage.getItem("borrador");

        });

    }

    ngDoCheck() {

        this._changeDetectionRef.detectChanges();

        if (localStorage.getItem("resumen")) {
            if (localStorage.getItem("resumen") == "true")
                this.resumen = true;
            else
                this.resumen = false
        }





    }

    ngOnChanges(changes: SimpleChanges) {
        //for (let propName in changes) {  
        //var change = changes[propName];
        //var curVal  = JSON.stringify(change.currentValue);
        // var prevVal = JSON.stringify(change.previousValue);
        //   }
        if (this.generico == true) {
            this.getDocumentos(localStorage.getItem("form"));

        } else {

            this.getDocumentos(this.form);

        }
        this.borradorId = sessionStorage.getItem("borrador");
        //console.log('ngOnchanges')

    }

    getDocumentos(id) {
        console.log(id)
        this.spinner.show()
        this.wizardSteps = [];
        this.data = [];
        this.actual = 0;
        this.start = 0;
        this.end = 0;
        this.limit = 4;
        this._documentoService.getDocumento().subscribe(
            response => {
                for (let x = 0; x < this.forms.length; x++) {
                    if (this.forms[x].name == id) {
                        //console.log(this.forms[x])
                        let promise = new Promise((resolve, reject) => {
                            for (let t = 0; t < this.forms[x].tabs.length; t++) {
                                this.wizardSteps.push(this.forms[x].tabs[t])

                            }
                            resolve(this.wizardSteps)
                        })

                        promise.then(() => {
                            for (let i = 0; i < 4; i++) {
                                this.data.push(this.wizardSteps[i]);
                            }

                            this.start = 0;
                            this.end = this.start + this.limit;

                        })




                    }
                }
                console.log()
                this.spinner.hide();
            },
            error => {
                console.log("Error", error)
                this.spinner.hide();
            }
        )
    }



    next(wizard) {

        let archivos = JSON.parse(localStorage.getItem("archivos_marcados"));
        var hay_error = false;
        //console.log(wizard);
        if (wizard.valid) {
            wizard.valid.forEach(item => {
                if (JSON.parse(localStorage.getItem(item))) {
                    //console.log("item", JSON.stringify(item));
                    //console.log("localStorage.getItem(item)", localStorage.getItem(item));
                    if (JSON.parse(localStorage.getItem(item)).length == 0) {
                        hay_error = true;

                    }
                } else {
                    hay_error = true;
                }
            })


            if (hay_error) {



                swal({
                    type: 'error',
                    title: "Faltan campos obligatorios",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(() => {
                    window.scroll(0, 0);
                });


            } else {


                if (archivos) {
                    if (archivos['archivosSubidos'] === true) { // se subieron todos los obligatorios
                        //if(this.avance)
                        this.forward();
                    }
                    if (archivos['archivosSubidos'] === false) {//no se han subido no deja pasar
                        swal({
                            type: 'error',
                            title: "Aún no subes los archivos obligatorios",
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar',
                            allowOutsideClick: false
                        }).then(() => {
                            window.scroll(0, 0);
                        });
                    }
                } else {
                    //if(this.avance)
                    //this.currentStep++;
                    this.forward();
                }



            }



        } else {
            if (archivos) {
                if (archivos['archivosSubidos'] === true) {
                    //if(this.avance)
                    this.forward();
                }
                if (archivos['archivosSubidos'] === false) {
                    swal({
                        type: 'error',
                        title: "Aún no subes los archivos que adjuntaste",
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        allowOutsideClick: false
                    }).then(() => {
                        window.scroll(0, 0);
                    });
                }
            } else {
                //if(this.avance)
                this.forward();
            }
        }
    }
    onNextFinalize() {

        //this.actual++;
        //this.avance = true
        //this.forward()
        console.log('on Next finalize')
    }
    forward() {
        //console.log('forward');

        this.wizard.navigation.goToNextStep();

        if (this.actual + 1 == this.wizardSteps.length) {//ultimo?                    
            console.log('if (this.actual + 1 == this.wizardSteps.length) RETURN ');
            return;
        }
        //console.log('this.actual++');
        //if (this.avance)
        this.actual++;
        this.avance = false;
        if (this.actual == this.end - 1 && this.actual != this.wizardSteps.length - 1) {
            this.data.push(this.wizardSteps[this.actual + 1]);
            this.data.splice(0, 1);
            this.end++;
            this.start++;
        }
    }

    back() {
        //this.wizard.navigation.goToPreviousStep();
        //
        console.log('back');

        if (localStorage.getItem("archivos_marcados") && this.actual + 1 != this.wizardSteps.length) {
            // localStorage.removeItem("archivos_marcados");
            //console.log('removeItem archivos_marcados');
        }

        if (this.actual == 0 && this.start == 0) {
            return;
        }


        this.actual--;

        if (this.actual == this.start && this.start > 0) {
            this.data.unshift(this.wizardSteps[this.start - 1]);
            this.data.splice(this.data.length - 1, 1)
            this.end--;
            this.start--;
        }
    }

    saveDraft() {
        this.dialog.open(crearBorradorComponent)

        // if (sessionStorage.getItem("borrador")) {
        //     this.borradorId = sessionStorage.getItem("borrador");
        // }

    }

    updateDraft() {
        this.infoBorrador = this.allStorage();
        this._userService.updateDraft(this.borradorId, this.infoBorrador).subscribe(
            response => {
                if (response.update) {
                    this.snackBar.open(response.message, 'Cerrar', {
                        duration: 3000
                    })
                } else {
                    this.snackBar.open(response.message, 'Cerrar', {
                        duration: 3000
                    })
                }
            },
            error => {
                console.log(error)
            }
        )
    }

    allStorage() {
        console.log(localStorage)

        let identity
        identity = JSON.parse(sessionStorage.getItem("identity-domCloud"))


        let solicitante = {
            rut: identity.rut,
            dv: identity.dv
        }

        localStorage.setItem("solicitante", JSON.stringify(solicitante));
        console.log(localStorage.getItem("solicitante"))

        return Object.keys(localStorage)
            .reduce((obj, k) => {
                console.log(localStorage.getItem(k), 'K', k)
                console.log('OBJ', obj)
                if (k == 'form' || k == 'formId' || k == 'formTitle' || k == 'ZipURL') {// para que 3.10 llegue completo                    
                    return { ...obj, [k]: typeof localStorage[k] !== 'undefined' ? localStorage.getItem(k) : '' }
                } else {
                    return { ...obj, [k]: typeof localStorage[k] !== 'undefined' ? JSON.parse(localStorage.getItem(k)) : '' }

                }
            }, {});
    }

    guardar_expediente() {

        this.formulariofinal = this.allStorage();
        this.spinner.show();
        console.log("this.formulariofinal", this.formulariofinal);

        this.filemaker.guardarExpediente(this.formulariofinal).subscribe(
            response => {
                this.spinner.hide();

                console.log("////// Respuesta del finalizar exp ////////")
                console.log(response)
                console.log("///////////////////////")
                if (response) {
                    this.store.dispatch(new FormActions.FormUpdate('0', ''))
                    localStorage.clear();
                    sessionStorage.removeItem('borrador');
                    swal({
                        type: 'success',
                        title: 'Solicitud enviada',
                        text: `
                                <p>Su solicitud de pre-ingreso fue recepcionada, una vez revisado sus documentos, la dirección de obras tomará contacto con usted, con el estado de su solicitud, la cual puede ser aceptada o rechazada.</p>
                                `,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                    }).then(
                        () => {
                            this._router.navigate(['/expedientes'])
                        }
                    );
                }
            },
            error => {
                console.log(error)
                //alert("Error: No se pudo guardar la solicitud")
                swal({
                    type: 'error',
                    title: "No se pudo guardar la solicitud",
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                }).then(
                    () => {

                    }
                );
                this.spinner.hide();

            }
        )
    }

    onAction(event?) {
        console.log(event)
    }

}